import ProcessingClient from '@/services/clients/processing';
import { User } from '@/models/User';
import { useMemoize } from '@vueuse/core';
import TokenService from '../../../../packages/frontend-authentication-app/src/services/token';
import { UserType } from '@/types';

// userId - it is cacheKey
const userMemoizeRequest= useMemoize((userId) => ProcessingClient.getUser().then(User.createFromData));
export default {
  getUser() {
    const tokenUser= TokenService.getUser();
    return userMemoizeRequest(tokenUser?.id);
  },

  async getUserType(): Promise<UserType | undefined>{
    if (!TokenService.hasToken()) return undefined;

    const user = await this.getUser();
    return user.userType;
  },
};

